<template>
  <div>
    <b-card-text>
      テキストを表示します
    </b-card-text>
    <b-form-group id="text" label="テキスト">
      <remark-editor class="text" v-model="innerValue.arguments.text"
        :warn="100" :danger="200"
      ></remark-editor>
    </b-form-group>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
import RemarkEditor from '@/components/RemarkEditor'
export default {
  props: {
    value: Object
  },
  components: {
    RemarkEditor
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
